import PropTypes from 'prop-types';

import { Button, DialogActions } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(DialogActions, {
  shouldForwardProp: (prop) => prop !== 'isRTL',
})(({ isRTL }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  margin: '1.4rem 0',
  ...(isRTL && {
    justifyContent: 'flex-start',
  }),
}));

const Actions = ({ actions, isRTL }) => (
  <StyledDialog isRTL={isRTL}>
    {actions?.map(({ label, onClick, color }) => (
      <Button
        key={label}
        variant="contained"
        color={color}
        disableElevation
        onClick={() => onClick && onClick()}
      >
        {label}
      </Button>
    ))}
  </StyledDialog>
);

Actions.defaultProps = {
  actions: [],
  isRTL: false,
};

Actions.propTypes = {
  actions: PropTypes.instanceOf(Array),
  isRTL: PropTypes.bool,
};

export default Actions;
